export const LOADING_PAYMENT = "LOADING_PAYMENT";
export const REMOVE_PAYMENT = "REMOVE_PAYMENT";
export const ADD_PAYMENT = "ADD_PAYMENT";
export const GET_PAYMENT = "GET_PAYMENT";
